import React from "react";
import { INVOICE_STATUS_FACES, TONE_CLASSES } from "../subscriptionState";
import type { InvoiceStatus } from "../types/subscriptions.types";

interface InvoiceStatusBadgeProps {
  status: InvoiceStatus;
}

/**
 * Where the term an invoice bought stands today, beside its number.
 *
 * Beside the number rather than in a column of its own, on both the table and
 * the phone's cards: the invoice number is what a row is identified by, and
 * where its term stands is a fact about that document rather than a fifth
 * thing to line up. It is also the one place a reader can see, at a glance,
 * which of several prepaid purchases is the one they are living on.
 *
 * The words and the colours are `INVOICE_STATUS_FACES`, which borrows the
 * status card's tones so a row and the card above it never say the same thing
 * two different ways.
 */
const InvoiceStatusBadge: React.FC<InvoiceStatusBadgeProps> = ({ status }) => {
  const face = INVOICE_STATUS_FACES[status];
  if (!face) return null;

  return (
    <span
      className={`inline-flex shrink-0 whitespace-nowrap rounded-full px-2 py-0.5 text-[12px] 3xl:text-[13px] font-medium ${
        TONE_CLASSES[face.tone]
      }`}
    >
      {face.label}
    </span>
  );
};

export default InvoiceStatusBadge;
